require("./confirmationService");
require("../../fhApp/currentUser/currentUser");
require('../../mainFrame/collapsableMenu/collapsableMenuService');
require('../../pricing/plans/plansService');

angular.module('app.registration.confirmation.confirmationController', [
  'app.registration.confirmation.confirmationService',
  'app.currentUser',
  'app.mainFrame.collapsableMenu.collapsableMenuService'
]).controller('app.registration.confirmation.confirmationController', [
  '$scope',
  '$stateParams',
  'app.registration.confirmation.confirmationService',
  'currentUser',
  '$state',
  'app.mainFrame.collapsableMenu.collapsableMenuService',
  'app.pricing.plans.plansService',
  /**
   * @param $scope
   * @param {RegistrationParams} $stateParams
   * @param confirmation
   * @param currentUser
   * @param $state
   * @param collapsableMenu
   * @param plansService
   */
  function ($scope, $stateParams, confirmation, currentUser, $state, collapsableMenu, plansService) {
    "use strict";

    $scope.username = null;
    $scope.password = null;
    $scope.ready = false;
    $scope.confirming = true;
    $scope.error = null;

    let init = () => {
      $scope.confirm();
    };

    $scope.confirm = function () {
      if ($stateParams.userId && $stateParams.confirmation) {
        let userId = parseInt($stateParams.userId);
        confirmation.confirm(userId, $stateParams.confirmation)
          .then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              $scope.confirming = false;

              if (response.status === 204) {
                $scope.ready = true;
              } else {
                $scope.error = response.data.error;
              }
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              $scope.error = response.data.error;
            }
          );
      }
    }

    $scope.login = function () {
      currentUser.login($scope.username, $scope.password)
        .then(function () {
          collapsableMenu.buildItems();
          if ($stateParams.plan_code) {
            plansService.retrieve({ plans: [$stateParams.plan_code] })
              .then(function (data) {
                let plan = _.find(data.plans, { plan_code: $stateParams.plan_code });
                $state.go('app.purchase.billingInfo', { plan: plan, team: $stateParams.team })
              })
          } else {
            $state.go('app.favorites');
          }
        })
        .catch(result => {
          $state.go('app.login', result);
        });
    }

    init();
  }
]);



// WEBPACK FOOTER //
// ./app.v2/components/registration/confirmation/confirmationController.js